import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
var createNamespaceContext = function createNamespaceContext(namespace) {
  var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'NamespacedContext';
  var Component = function Component(props) {
    var newData = _defineProperty({}, namespace, props.data);
    return /*#__PURE__*/React.createElement(AnalyticsContext, {
      data: newData
    }, React.Children.only(props.children));
  };
  Component.displayName = displayName;
  return Component;
};
export default createNamespaceContext;